import { styled } from "@mui/material/styles";
import { Skeleton, Stack } from "@mui/material";

import { HubButton, HubHookFormSelect } from "../../components";

export const StyledSelect = styled(HubHookFormSelect)({
  width: 125,
  padding: "5px 10px",
  borderRadius: 6,
  svg: {
    width: 12,
    height: 12,
    margin: "5px 5px 0px 0px",
  },
});

export const StyledHubButton = styled(HubButton)(({ theme }) => ({
  fontSize: "12px",
  ".MuiStack-root": {
    gap: "5px",
    flexDirection: "row-reverse",
    ".MuiTypography-root": {
      fontWeight: 400,
      // color: theme.palette.hubColors.greyDark,
    },
  },
  svg: {
    width: "12px",
    height: "12px",
  },
}));

export const StyledCardStack = styled(Stack)(({ theme }) => ({
  gap: "15px",
  height: "100%",
  overflow: "auto",
  padding: "15px",
  backgroundColor: theme.palette.hubColors.white,
  borderLeft: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
  "::-webkit-scrollbar": {
    display: "none",
  },
}));

export const StyleDisplayStack = styled(Stack)({
  display: "grid",
  gridTemplateColumns: "75px auto 250px",
  height: "calc(100% - 51px);",
  overflow: "hidden",
  ".hub-nav-bar": {
    width: "100%",
    maxWidth: "175px",
  },
});

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
  width: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.05)",
  "&:after": {
    background:
      "linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.15), transparent)",
  },
}));
